// assets
import {
    UserOutlined,
    SettingOutlined,
    TranslationOutlined,
    ApiOutlined,
} from '@ant-design/icons';
import { NavGroupType } from './types';

// icons
const icons = {
    UserOutlined,
    SettingOutlined,
    TranslationOutlined,
    ApiOutlined,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const admin: NavGroupType = {
    id: 'group-admin',
    title: 'menu.admin.title',
    type: 'group',
    children: {} as { [key: string]: any },
    disabled: {
        qlive_core_admin_settings_enabled: {
            id: 'settings-admin',
            title: 'menu.admin.items.settings',
            type: 'item',
            url: '/admin/settings',
            icon: icons.SettingOutlined,
            breadcrumbs: false,
        },
        qlive_core_admin_translation_locale_list: {
            id: 'translation-admin',
            title: 'menu.admin.items.translation',
            type: 'item',
            url: '/admin/locale',
            icon: icons.TranslationOutlined,
            breadcrumbs: false,
        },
        qlive_core_admin_user_list: {
            id: 'user-admin',
            title: 'menu.admin.items.user',
            type: 'item',
            url: '/admin/user',
            icon: icons.UserOutlined,
            breadcrumbs: false,
        },
        qlive_core_admin_clients_list: {
            id: 'client-admin',
            title: 'menu.admin.items.client',
            type: 'item',
            url: '/admin/clients',
            icon: icons.ApiOutlined,
            breadcrumbs: false,
        },
    },
};

export default admin;
